import React, { useRef, useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./LarchMes.css";
import { FaEye, FaCheckCircle, FaHistory, FaChartLine } from "react-icons/fa";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import { motion } from "framer-motion";
import collab from "../../assets/collab.png";
import portfolio1 from "../../assets/Company.jpg";
import portfolio2 from "../../assets/Company2.jpg";
import portfolio3 from "../../assets/Company3.jpg";
import success1 from "../../assets/Company4.jpg";
import success2 from "../../assets/health.png";
import success3 from "../../assets/retail.png";
import { Link } from "react-router-dom";
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";

function LarchMes() {
  const sliderRef = useRef(null);
  const intervalRef = useRef(null);

  const stories = [
    {
      bgImage: success1,
      name: "Automotive Industry",
      story:
        "Reduced downtime by 25% and improved production efficiency across multiple plants.",
      person: "John Doe",
      position: "Plant Manager",
    },
    {
      bgImage: success2,
      name: "Electronics Manufacturing",
      story:
        "Achieved 100% traceability and streamlined compliance reporting globally.",
      person: "Sarah Lee",
      position: "Head of Quality",
    },
    {
      bgImage: success3,
      name: "Medical Devices",
      story:
        "Enhanced product quality with automated quality checks and real-time monitoring.",
      person: "Raj Kumar",
      position: "Operations Director",
    },
  ];

  // helper to compute gap (robust)
  const getGap = (container) => {
    if (!container) return 32;
    try {
      const gs = window.getComputedStyle(container);
      const gapStr =
        gs.getPropertyValue("gap") ||
        gs.getPropertyValue("column-gap") ||
        gs.getPropertyValue("grid-column-gap") ||
        "32px";
      const g = parseFloat(gapStr);
      return Number.isFinite(g) ? g : 32;
    } catch {
      return 32;
    }
  };

  // handle manual scroll buttons (uses card width + gap)
  const handleScroll = (direction) => {
    const slider = sliderRef.current;
    if (!slider) return;
    const card = slider.querySelector(".success-card.full-card");
    const gap = getGap(slider);
    const amount = (card?.offsetWidth || 700) + gap;
    slider.scrollBy({ left: direction === "left" ? -amount : amount, behavior: "smooth" });
  };

  // auto-scroll with pause on hover (and touch)
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const card = slider.querySelector(".success-card.full-card");
    if (!card) return;

    const totalCards = stories.length;
    let index = 0;

    const startAutoScroll = () => {
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        index++;
        if (index >= totalCards) index = 0;

        // recalc card width each tick for responsiveness
        const currentCard = slider.querySelector(".success-card.full-card");
        const gap = getGap(slider);
        const cardWidth = (currentCard?.offsetWidth || card.offsetWidth) + gap;

        slider.scrollTo({ left: cardWidth * index, behavior: "smooth" });
      }, 4000); // 4s per slide (same feel as AboutUs)
    };

    const stopAutoScroll = () => {
      clearInterval(intervalRef.current);
    };

    // start auto-scroll
    startAutoScroll();

    // pause while user hovers or touches the slider
    slider.addEventListener("mouseenter", stopAutoScroll);
    slider.addEventListener("mouseleave", startAutoScroll);
    slider.addEventListener("touchstart", stopAutoScroll, { passive: true });
    slider.addEventListener("touchend", startAutoScroll, { passive: true });

    // cleanup on unmount
    return () => {
      clearInterval(intervalRef.current);
      slider.removeEventListener("mouseenter", stopAutoScroll);
      slider.removeEventListener("mouseleave", startAutoScroll);
      slider.removeEventListener("touchstart", stopAutoScroll);
      slider.removeEventListener("touchend", startAutoScroll);
    };
  }, [stories.length]);
  
   useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Header outside scoped container so page styles don't affect it */}
      <Header />

      {/* page content wrapper (your existing wrapper) */}
      <div className="larchmes-page">
        {/* Hero Section */}
        <section className="larchmes-hero" style={{ backgroundImage: `url(${collab})` }}>
          <div className="larchmes-hero-overlay"></div>
          <h1 className="larchmes-hero-title">Manufacturing Execution System (MES)</h1>
          <p className="larchmes-hero-subtitle">The Real-Time Engine for Your Factory</p>
        </section>

        {/* Intro */}
        <section className="larchmes-intro">
          <h2>What is MES?</h2>
          <p>
            <strong>
              A Manufacturing Execution System (MES) is a dynamic software solution
              that controls, monitors, and documents the entire production process
              from start to finish on the factory floor.
            </strong>
          </p>
          <p>
            <strong>
              It acts as the crucial link between high-level business planning
              systems (like ERP) and the actual, moment-to-moment equipment and
              operators. By capturing real-time data from machines, sensors, and
              personnel, an MES ensures that production is executed correctly,
              efficiently, and with perfect traceability.
            </strong>
          </p>
        </section>

        {/* Benefits */}
        <section className="larchmes-benefits">
          <h2>Key Benefits of Larch MES</h2>
          <div className="larchmes-benefit-cards">
            <div className="larchmes-benefit-card">
              <FaEye className="benefit-icon" />
              <h3>Real-Time Visibility</h3>
              <p>See production status and resource utilization instantly across your factory.</p>
            </div>
            <div className="larchmes-benefit-card">
              <FaCheckCircle className="benefit-icon" />
              <h3>Quality Enforcement</h3>
              <p>Automatically enforce checks to minimize defects and rework, ensuring high standards.</p>
            </div>
            <div className="larchmes-benefit-card">
              <FaHistory className="benefit-icon" />
              <h3>Full Traceability</h3>
              <p>Create a complete electronic history (genealogy) for every product to meet compliance needs.</p>
            </div>
            <div className="larchmes-benefit-card">
              <FaChartLine className="benefit-icon" />
              <h3>Operational Excellence</h3>
              <p>Boost OEE (Overall Equipment Effectiveness) and drive continuous improvement initiatives.</p>
            </div>
          </div>
        </section>

{/* Portfolio */}
<section className="larchmes-portfolio">
  <h2 className="larchmes-portfolio-title">Our Portfolio</h2>
  <div className="larchmes-portfolio-grid">
    <div className="larchmes-portfolio-card">
      <img src={portfolio1} alt="Portfolio 1" />
      <h3>Injection Moulding Mes</h3>
       <Link to="/injection-mould" className="explore-link">
    Explore More →
  </Link>
  </div>

    <div className="larchmes-portfolio-card">
      <img src={portfolio2} alt="Portfolio 2" />
      <h3>Wirring Harness Mes</h3>
      <Link to="/Wirringharness" className="explore-link">
    Explore More →
  </Link>
    </div>

    <div className="larchmes-portfolio-card">
      <img src={portfolio3} alt="Portfolio 3" />
      <h3>Cable Assembly Mes</h3>
      <Link to="/CableAssembly" className="explore-link">
    Explore More →
  </Link>
    </div>

    <div className="larchmes-portfolio-card">
      <img src={portfolio3} alt="Portfolio 4" />
      <h3>PCB Manufacturing Mes</h3>
      <Link to="/PCBManufucture" className="explore-link">
    Explore More →
  </Link>
    </div>
  </div>
</section>




        {/* Success Stories: exact behavior like AboutUs (auto-scroll + pause on hover) */}
        <section className="success-section">
          <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            Success Stories
          </motion.h2>

          <div className="success-slider-wrapper">
            {/* Left Arrow (uses computed card width) */}
            <button className="scroll-btn left" onClick={() => handleScroll("left")}>
              ‹
            </button>

            {/* Scrollable Cards (this is the sliderRef used by auto-scroll) */}
            <div className="success-slider-scrollable" ref={sliderRef}>
              {stories.map((item, i) => (
                <div
                  key={i}
                  className="success-card full-card"
                  style={{
                    backgroundImage: `url(${item.bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="success-overlay" />
                  <div className="success-content">
                    <h3>{item.name}</h3>
                    <p>“{item.story}”</p>
                    <p className="person">{item.person}</p>
                    <p className="position">{item.position}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Right Arrow */}
            <button className="scroll-btn right" onClick={() => handleScroll("right")}>
              ›
            </button>
          </div>
        </section>
      </div>

      {/* Footer stays outside the scoped wrapper */}
      <Footer />
      <ERPChatbot />
    </>
  );
}

export default LarchMes;
